import { render, staticRenderFns } from "./AffiliationInfoModal.vue?vue&type=template&id=78694ae0&scoped=true&"
import script from "./AffiliationInfoModal.vue?vue&type=script&lang=js&"
export * from "./AffiliationInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./AffiliationInfoModal.vue?vue&type=style&index=0&id=78694ae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78694ae0",
  null
  
)

component.options.__file = "AffiliationInfoModal.vue"
export default component.exports